export const PRELOADER_COLOR_LIGHT = "#D7E2EF";

export const PRELOADER_COLOR_DARK = "#30405F";
